"use strict";
import _ from "underscore";
export function DocumentBatchGroupCreator(documentBatches, selector) {
  const documentGroups = _.flatten(
    documentBatches.map((db) => db.document_groups)
  );
  const ignoredDocumentGroups = documentGroups.filter((d) => !!d.ignored);
  function groupDocuments() {
    const groups = {};
    documentBatches.forEach((batch, index) => {
      const groupId = index + 1;
      const documents = _.select(batch.documents, selector);
      const notIgnoredDocuments = documents.filter(
        (d) => ignoredDocumentGroups.filter((dg) => dg.id === d.document_group_id).length === 0
      );
      const areLoadDocuments = !_.some(notIgnoredDocuments, _.property("carrier_invoice_id")) && !_.some(notIgnoredDocuments, _.property("factor_invoice_id"));
      const group = {
        number: groupId,
        documents: notIgnoredDocuments,
        name: batch.email_message ? batch.email_message.subject : "Uploaded Documents",
        groupType: "batched",
        url: batch.email_message ? "/index-document-batches/" + batch.id : null,
        created_at: new Date(batch.created_at),
        areLoadDocuments,
        selected: true
      };
      if (group.documents.length > 0) {
        groups[groupId] = group;
      }
    });
    const sorted = _.sortBy(
      _.values(groups),
      _.property("created_at")
    ).reverse();
    if (sorted.length > 0) {
      sorted[0].groupType = "batched--primary";
    }
    return sorted;
  }
  return {
    groups: groupDocuments(),
    groupSelected: function() {
    }
  };
}
